import gql from 'graphql-tag';
import * as i0 from "@angular/core";
import * as i1 from "../shared/services/graph-qlclient.service";
export class EstadoInventarioService {
    constructor(gqlclient) {
        this.gqlclient = gqlclient;
    }
    obtenerTodos(callback) {
        this.gqlclient.query({
            query: gql `
        {
          estado_inventario {
            obtenerTodos {
              mensajes {
                codigo
                contexto
                texto
                tipo
              }
              respuesta {
                registros {
                  codigo
                  nombre
                  descripcion
                }
              }
            }
          }
        }
        `,
            variables: {},
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.estado_inventario.obtenerTodos;
            callback({ mensajes, respuesta });
        });
    }
}
EstadoInventarioService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function EstadoInventarioService_Factory() { return new EstadoInventarioService(i0.ɵɵinject(i1.GraphQLClient)); }, token: EstadoInventarioService, providedIn: "root" });
